import Api from './ApiWAService'

export default {
    create(data) {
        return Api().post(`whatsapp/send-message`,
            {
                "to": data.phone, 
                "templateName": "simple", 
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            { "type": "text", "text": data.message }
                        ]
                    },
                ]
            }
        );
    },
}